/*
 * xentz-promode.js
 * ---------------------------------------------------------------------------
 * Pro-Modus / Direktsprung im XentzCode-Finder.
 *
 * Wird nur auf der Finder-Seite geladen. Wenn die URL ?step=2 (oder ?step=3)
 * enthaelt, schickt dieses Skript den Step-Assistenten automatisch auf den
 * gewuenschten Schritt, ohne dass ein Markenduft gesucht werden muss.
 *
 * Umsetzung ohne Aenderung an der Wizard-Datei: Der Assistent wechselt den
 * Schritt ueber seinen "Weiter"-Button. Bei leerer Auswahl haelt der Wizard
 * diesen Button deaktiviert; wir aktivieren ihn und klicken ihn so lange, bis
 * der Ziel-Schritt aktiv ist (funktioniert, sobald der Wizard seine Daten
 * geladen und den Button-Listener gesetzt hat).
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var params;
  try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
  var target = params.get('step');
  if (target !== '2' && target !== '3') return;

  var WIZ = '[data-xentz-wizard]';

  function labelActive(n) {
    var s = document.querySelector(WIZ + ' .xw-step[data-goto="' + n + '"]');
    return !!(s && s.classList.contains('active'));
  }
  function panelActive(n) {
    var p = document.querySelector(WIZ + ' .xw-panel[data-panel="' + n + '"]');
    return !!(p && p.classList.contains('active'));
  }
  function reached() {
    return labelActive(target) || panelActive(target);
  }

  var tries = 0;
  var MAX = 200; // ~12s bei 60ms
  var iv = setInterval(tick, 60);
  if (document.readyState !== 'loading') tick();

  function tick() {
    if (++tries > MAX) { clearInterval(iv); return; }
    var wiz = document.querySelector(WIZ);
    if (!wiz) return;                 // Wizard noch nicht im DOM
    if (reached()) { clearInterval(iv); return; }

    var next = wiz.querySelector('#xwNext');
    if (!next) return;
    // Bei leerer Auswahl haelt der Wizard "Weiter" deaktiviert -> selbst aktivieren.
    next.disabled = false;
    next.click();                     // wirkt erst, wenn der Wizard-Listener steht
  }
})();
